import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import growthIcon from "../../../Assets/Icons/growthpayment.svg";
import paymentIcon from "../../../Assets/Icons/Payment method.svg";
import paymentIcon2 from "../../../Assets/Icons/paymenticon.svg";
import GenericTable from "../../../Components/GenericTable";
import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import "./style.css";
import {
  getPaymentDetails,
  manageSubscriptionAPI,
} from "../../../API/payments";
import { ClipLoader } from "react-spinners";

const PaymentDetails = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingManage, setLoadingManage] = useState(false);
  const [paymentDetailData, setPaymentDetailData] = useState({});

  const fetchPaymentDetails = async () => {
    try {
      setLoading(true);
      const response = await getPaymentDetails();
      if (Math.floor(response?.status / 100) === 2) {
        const data = response?.data || [];
        setPaymentDetailData(data);
      } else {
        message.error("Unexpected response from server.");
      }
    } catch (error) {
      message.error("Failed to fetch dashboard data Email Volume.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentDetails();
  }, []);

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str?.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleUpgrade = () => {
    navigate("/pricing-plan", {
      state: { noBg: true },
    });
  };

  const manageSubscription = async () => {
    try {
      setLoadingManage(true);

      const response = await manageSubscriptionAPI();

      if (Math.floor(response?.status / 100) === 2) {
        const portalUrl = response?.data?.portal_url;

        if (portalUrl) {
          window.location.href = portalUrl;
        } else {
          message.success("Error getting the checkout URL");
        }
      } else {
        message.error(response?.data?.message || "Checkout failed");
      }
    } catch (error) {
      message.error("Something went wrong while initiating checkout");
    } finally {
      setLoadingManage(false);
    }
  };

  const getDaysRemaining = (periodEnd) => {
    if (!periodEnd) return 0;

    const today = new Date();
    const endDate = new Date(periodEnd);

    // Reset time to avoid timezone issues
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const diffTime = endDate - today;

    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays > 0 ? diffDays : 0; // avoid negative values
  };

  const getPercentage = (value, total) => {
    if (!total || total === 0) return 0;
    return Math.round((value / total) * 100);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
      key: "invoice_number",
      sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      enableSearch: true,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => {
        const numA = parseFloat(a.amount.replace(/[$,]/g, ""));
        const numB = parseFloat(b.amount.replace(/[$,]/g, ""));
        return numA - numB;
      },
      enableSearch: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: "Paid", value: "paid" },
        { text: "Pending", value: "Pending" },
        { text: "Overdue", value: "Overdue" },
      ],
      onFilter: (value, record) => record.status === value,
      render: (status) => {
        let className = "";
        if (status === "Paid") className = "status-paid";
        else if (status === "Pending") className = "status-pending";
        else if (status === "Overdue") className = "status-overdue";

        return <span className={className}>{status}</span>;
      },
    },
    {
      title: "Invoice",
      dataIndex: "invoice_pdf",
      key: "invoice_pdf",
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => window.open(record?.invoice_pdf, "_blank")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: 0,
          }}
        >
          <DownloadOutlined
            style={{ fontSize: "14px", fontWeight: "700", color: "#4928FD" }}
          />
          <span className="download-text">Download PDF</span>
        </Button>
      ),
    },
  ];

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="loader-container"
        >
          <ClipLoader size={50} color={"#123abc"} loading={loading} />
        </div>
      ) : (
        <div className="payment-page">
          <div className="payment">
            <div className="subscription-card">
              <div className="card-header">
                <div className="header-left">
                  <img src={growthIcon} alt="growth" className="plan-icon" />
                  <div className="header-wrapper">
                    <div className="plan-title">
                      {capitalizeFirstLetter(paymentDetailData?.plan?.name)}
                      Plan
                    </div>
                    <div className="sub-title">
                      {paymentDetailData?.plan?.amount}{" "}
                      {paymentDetailData?.plan?.currency} per{" "}
                      {paymentDetailData?.plan?.interval}
                    </div>
                  </div>
                </div>

                <span className="plan-status active">
                  {capitalizeFirstLetter(paymentDetailData?.plan?.status)}
                </span>
              </div>

              <div className="usage-section">
                <div className="usage-header">
                  <span className="usage-label">Email API Usage</span>
                  <span className="usage-percentage">
                    {getPercentage(
                      paymentDetailData?.usage?.emails_sent,
                      paymentDetailData?.usage?.max_emails
                    )}
                    %
                  </span>
                </div>

                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${getPercentage(
                        paymentDetailData?.usage?.emails_sent,
                        paymentDetailData?.usage?.max_emails
                      )}%`,
                    }}
                  ></div>
                </div>

                <div className="usage-details">
                  <span className="email-count">
                    {paymentDetailData?.usage?.emails_sent} /{" "}
                    {paymentDetailData?.usage?.max_emails} emails
                  </span>
                  <span className="reset-info">
                    Resets in{" "}
                    {getDaysRemaining(paymentDetailData?.usage?.period_end)}{" "}
                    days
                  </span>
                </div>
              </div>
            </div>

            <div className="subscription-card">
              <div className="payment-section">
                <div className="card-header">
                  <div className="header-left">
                    <img src={paymentIcon} alt="growth" className="plan-icon" />
                    <div className="header-wrapper">
                      <div className="plan-title">Payment Method</div>
                    </div>
                  </div>
                </div>

                <div className="payment-details">
                  <div className="payment-wrapper">
                    <div className="card-info">
                      <img
                        src={paymentIcon2}
                        alt="payment icon"
                        className="plan-icon"
                      />
                      <div className="wrapper">
                        <div className="card-type">
                          {paymentDetailData?.payment_method?.brand} ending in{" "}
                          {paymentDetailData?.payment_method?.last4}
                        </div>
                        <div className="card-expiry">
                          Expires {paymentDetailData?.payment_method?.exp_month}
                          /{paymentDetailData?.payment_method?.exp_year}
                        </div>
                      </div>
                    </div>
                    <div className="checked"></div>
                  </div>
                </div>
              </div>

              <div className="billing-section">
                <p className="next-billing">
                  Next billing date:
                  <span>{paymentDetailData?.usage?.period_end}</span>
                </p>
              </div>
            </div>

            <div className="btns">
              {/* <div className="btn-container">
                <Button type="primary" onClick={handleUpgrade}>
                  Upgrade Plan
                </Button>
              </div> */}
              <div className="btn-container">
                <Button
                  className="can-btn"
                  type="primary"
                  onClick={manageSubscription}
                  loading={loadingManage}
                >
                  Manage Subscription
                </Button>
              </div>
            </div>
          </div>
          <div className="table">
            <GenericTable
              dataSource={paymentDetailData?.invoices}
              columns={columns}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentDetails;
